import React from 'react';
import { Result, Button } from 'antd';
import { Link, useParams } from 'react-router-dom';

const EmptyInfluencerComponent = ({ children, button }) => {
  const params = useParams();
  return (
    <Result
      style={{ width: '100%' }}
      title={children}
      extra={
        button?
          <Button className="common_button"
            key="console">
            <Link to={`/brand/${params.companyId}/discover`}>Go to Discovery</Link>
          </Button>:
          null
      }
    />
  );
};

export default EmptyInfluencerComponent;
